export class PaytmResponse {

    acquirementId: string;
    acquiringBank: string;
    aid: string;
    authCode: string;
    bankMid: string;
    bankResponseCode: string;
    bankResponseMessage: string;
    bankTid: string;
    cardScheme: string;
    cardType: string;
    extendedInfo: string;
    issuerMaskCardNo: string;
    issuingBankName: string;
    merchantExtendedInfo: string;
    merchantReferenceNo: string;
    merchantTransactionId: string;
    payMethod: string;
    paytmMid: string;
    paytmTid: string;
    resultCode: string;
    resultCodeId: string;
    resultMsg: string;
    resultStatus: string;
    retrievalReferenceNo: string;
    transactionAmount: string;
    transactionDateTime: string;
}
